import PageLayout from '../components/layout/PageLayout';
import ContactForm from '../components/ContactForm';
import Seo from '../components/Seo';
import './ContactsPage.css';

export default function ContactsPage() {
  return (
    <PageLayout title="Контакты и поддержка">
      <Seo
        title="Контакты — Recvisit"
        description="Контакты и реквизиты Recvisit. Поддержка и форма обратной связи."
        canonicalPath="/contacts"
      />
      <div className="container">
        <div className="contacts-grid">
          <section className="contacts-card">
            <h2 className="contacts-h2">Связаться с нами</h2>
            <p className="contacts-p">
              Напишите нам — мы ответим и поможем с подключением, настройкой и вопросами по сервису.
            </p>
            <ul className="contacts-list">
              <li>
                <strong>Email:</strong> <a href="mailto:info@recvi.ru">info@recvi.ru</a>
              </li>
              <li>
                <strong>Панель управления:</strong>{' '}
                <a href="https://panel.recvi.ru" target="_blank" rel="noopener noreferrer">
                  panel.recvi.ru
                </a>
              </li>
              <li>
                <strong>Регистрация:</strong>{' '}
                <a href="https://reg.recvi.ru" target="_blank" rel="noopener noreferrer">
                  reg.recvi.ru
                </a>
              </li>
            </ul>

            <div className="contacts-note">
              Срок ответа: обычно в течение 1 рабочего дня.
            </div>
          </section>

          <section className="contacts-card">
            <h2 className="contacts-h2">Реквизиты</h2>
            <div className="contacts-requisites">
              <div><strong>Индивидуальный предприниматель Шмелева Екатерина Владимировна</strong></div>
              <div>ИНН: 482306497385</div>
              <div>ОГРНИП: 324480000041882</div>
              <div>Адрес: Липецкая область, г. Липецк, ул. Советская, д. 4, оф. 619</div>
            </div>
            <p className="contacts-p">
              Юридически значимые сообщения направляйте на email <a href="mailto:info@recvi.ru">info@recvi.ru</a>.
            </p>
          </section>
        </div>
      </div>

      <ContactForm />
    </PageLayout>
  );
}

